import { AnimatePresence } from 'framer-motion'
import React, { useState } from 'react'
import pen from '../../assets/icons/pen.svg'
import EditMedia from './EditMedia'

const MediaRow = ({ media, index, updateData }) => {
  const [edit, setEdit] = useState(false)

  return (
    <>
      <div className={`${index % 2 === 0 ? '' : ' bg-gray/20'} flex py-2`}>
        <div className="flex-1 p-2 items-center justify-center flex">
          <img src={media.icon} className=" w-10 h-10 rounded-full" alt="" />
        </div>
        <div className="flex-1 p-2 items-center justify-center flex">
          {media.title}
        </div>
        <div className="flex-1 p-2 items-center justify-center flex">
          {media.address}
        </div>

        <div className="flex-1 p-2 items-center justify-center flex gap-3">
          <button
            onClick={() => setEdit(true)}
            className=" w-6 h-6 flex border-[1px] justify-center items-center rounded-sm border-darkBlue text-blueButton  p-1 aspect-square hover:bg-blue-600"
          >
            <span>
              <img src={pen} alt="" />
            </span>
          </button>
        </div>
      </div>
      <AnimatePresence>
        {edit && (
          <EditMedia
            active={edit}
            close={() => setEdit(false)}
            media={media}
            updateData={updateData}
          />
        )}
      </AnimatePresence>
    </>
  )
}

export default MediaRow
